"use client";

import { motion } from "framer-motion";
import { AgentCta } from "@/components/homepage/agent-cta";
import { BreachesSection } from "./breaches-section";

export function BreachesCta() {
  return (
    <BreachesSection>
      <motion.section
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="mb-16 rounded-(--radius-hero) p-8 text-center sm:p-12"
      >
        <h2 className="mb-8 text-4xl font-semibold leading-[1.05] tracking-tight sm:text-6xl md:text-7xl">
          Built for
          <br className="hidden sm:inline" /> humans and AI
        </h2>
        <AgentCta curlCommand={`curl https://developer.encrata.com/api/lookup/email/password/breaches -H "Authorization: Bearer YOUR_API_KEY" -H "Content-Type: application/json" -d '{"sha1": "5BAA61E4C9B93F3F0682250B6CF8331B7EE68FD8"}'`} />
      </motion.section>
    </BreachesSection>
  );
}
